import { REACT_APP_API_PREFIX } from "config/env";
import { DELETE, GET, POST, PUT } from "constants/methods";

const service = "cpfm";
const careerSkills = `${REACT_APP_API_PREFIX}/${service}/careerSkills`;

export function getCareerSkills(filters) {
  const url = `${careerSkills}${
    filters ? `?filters=${JSON.stringify(filters)}` : ""
  }`;
  return {
    method: GET,
    url,
  };
}

export function getCareerSkillById(id) {
  const url = `${careerSkills}/${id}/full`;
  return {
    method: GET,
    url,
  };
}

export function updateCareerSkill(id, body) {
  const url = `${careerSkills}/${id}`;
  return {
    method: PUT,
    url,
    body,
  };
}

export function deleteCareerSkill(id) {
  const url = `${careerSkills}/${id}`;
  return {
    method: DELETE,
    url,
  };
}

export function createCareerSkill(body) {
  const url = `${careerSkills}`;
  return {
    method: POST,
    url,
    body,
  };
}
